import { isEmpty, uniqBy, cloneDeep } from 'lodash';
import t from './ColorLibrary.type';
import { setArrayByCase } from '../../../../Components/helper';

const initlialState = {
  ColorLibList: [],
  ColourOptions: [],
  ColorLibGroup: [],
  colourSupportingDocs: [],
  ColorLibGroupAdd: {},
  ColorLibGroupEdit: {},
  totalRecords_ColorLibList: 0,
  mergedPdfUrl: '',
  ColorWaysLibList: [],
  totalRecords_ColorWaysLibList: 0,
  ColorLibGroupList: [],
  ColourGroupPageWiseList: [],
  totalColourGroupCount: 0,
};

const ColorLibrary = (state = initlialState, action) => {
  switch (action.type) {
    case t.FETCH_COLORS: {
      let colourWaysList = [];
      let totalCounts = 0;
      if (action.payload.isToLoadPaginationWise) {
        colourWaysList = cloneDeep(setArrayByCase(state.ColorLibList, action.payload));
        totalCounts = action.payload.totalDocuments;
      } else {
        colourWaysList = !isEmpty(action.payload) ? [...action.payload] : [];
        totalCounts = action?.payload?.length ? action.payload.length : 0;
      }
      return {
        ...state,
        ColorLibList: colourWaysList,
        totalRecords_ColorLibList: totalCounts,
      };
    }
    case t.FETCH_OPTIONS:
      return {
        ...state,
        ColourOptions: !isEmpty(action.payload) ? [...action.payload] : [],
      };
    case t.FETCH_COLORS_SUPPORTING_DOCUMENTS:
      return {
        ...state,
        colourSupportingDocs: uniqBy([...state.colourSupportingDocs, ...action.payload], '_id'),
      };
    case t.EDIT_SUPPORTING_DOCUMENTS:
      const arr = state.colourSupportingDocs.map((element) => {
        return element._id === action.payload[0]._id ? action.payload[0] : element;
      });
      return {
        ...state,
        colourSupportingDocs: [...arr],
      };
    case t.FETCH_COLORS_GROUP:
      return {
        ...state,
        ColorLibGroup: !isEmpty(action.payload) ? [...action.payload] : [],
      };

    case t.FETCH_COLORS_GROUP_EDIT:
      return {
        ...state,
        ColorLibGroupEdit: action.payload && Object.values(action.payload).length ? action.payload : {},
      };

    case t.ADD_COLORS:
      const oldColorList = JSON.parse(JSON.stringify(state.ColorLibList));
      const newColorList = [action.payload, ...oldColorList];
      return {
        ...state,
        ColorLibList: newColorList,
      };

    case t.ADD_COLORS_GROUP:
      return {
        ...state,
        ColorLibGroupAdd: action.payload && Object.values(action.payload).length ? action.payload : {},
      };

    case t.EDIT_COLORS:
      const previousColorList = JSON.parse(JSON.stringify(state.ColorLibList));
      const updatedColorList = [action.payload, ...previousColorList];
      return {
        ...state,
        ColorLibList: updatedColorList,
      };

    case t.EDIT_COLORS_GROUP:
      const previousColorGroupList = JSON.parse(JSON.stringify(state.ColorLibGroup));
      const updatedColorGroupList = [action.payload, ...previousColorGroupList];
      return {
        ...state,
        ColorLibGroup: updatedColorGroupList,
      };

    case t.DELETE_COLORS:
      const originalColorList = JSON.parse(JSON.stringify(state.ColorLibList));
      const deletedColorList = [action.payload, ...originalColorList];
      return {
        ...state,
        ColorLibList: deletedColorList,
      };
    case t.DELETE_COLORS_GROUPS:
      const originalColorGroupList = JSON.parse(JSON.stringify(state.ColorLibGroup));

      let deletedColorGroupList = [action.payload, ...originalColorGroupList];
      deletedColorGroupList = deletedColorGroupList.filter((deletedColorGroup) => deletedColorGroup[1]?.data._id !== action.payload.id);
      return {
        ...state,
        ColorLibGroup: deletedColorGroupList,
      };

    case t.DESABLE_COLOR:
      return {
        ...state,
        ColorLibList: action.payload || [],
      };

    case t.CLEAR_DOCUMENTS:
      return {
        ...state,
        colourSupportingDocs: [],
      };

    case t.EMPTY_REDUCER:
      return {
        ...state,
        ColorLibList: [],
        ColorLibGroup: [],
        ColorLibGroupAdd: {},
        ColorLibGroupEdit: {},
        totalRecords_ColorLibList: 0,
      };

    case t.MERGED_PDF_PREVIEW:
      return {
        ...state,
        mergedPdfUrl: action.payload,
      };
    case t.MERGED_PDF_DELETE:
      return {
        ...state,
        mergedPdfUrl: '',
      };

    case t.REMOVE_COLOUR_SUPPORTING_DOCUMENTS:
      return {
        ...state,
        colourSupportingDocs: uniqBy([...action.payload], '_id'),
      };

    case t.FETCH_COLORS_LIST:
      return {
        ...state,
        ColorWaysLibList: !isEmpty(action.payload) ? [...action.payload] : [],
        totalRecords_ColorWaysLibList: action?.payload?.length ? action.payload.length : 0,
      };

    case t.FETCH_COLORS_GROUP_LIST:
      return {
        ...state,
        ColorLibGroupList: !isEmpty(action.payload) ? [...action.payload] : [],
      };
    case t.FETCH_COLOUR_GROUP_PAGINATION:
      const cloneColourGrup = cloneDeep(setArrayByCase(state.ColourGroupPageWiseList, action.payload));
      return {
        ...state,
        ColourGroupPageWiseList: cloneColourGrup,
        totalColourGroupCount: action.payload.totalColourGroupCount,
      };

    default:
      return state;
  }
};

export default ColorLibrary;
